import { injectIntl, IntlShape } from 'react-intl';
import { useMemo } from 'react';
import { Listings } from 'containers/AppContainer/typings';
import VictimExpertise from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/VictimExpertise';
import CivilWithNonCompensation from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilWithNonCompensation';
import CivilJudgementRecapVictim from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/CivilJudgementRecapVictim';
import JudgementNonCompensationRecap from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/JudgementNonCompensationRecap';
import VehicleExpertise from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/VehicleExpertise';
import CivilJudgementRecapVehicle from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/CivilJudgementRecapVehicle';

export interface GeneralCivilProceedingProps {
  intl: IntlShape;
  judgementAddId?: any;
  judgementAddDocExpertises?: any;
  dahirAmounts?: any;
  isAppeal?: boolean;
  victim?: any;
  setExpertiseFieldValue?: Function;
  handleVictimChange?: Function;
  index?: any;
  expertiseType?: string;
  isInputChanged?: any;
  expertises?: any;
  mode: any;
  setJudgementOnMeritsRequest?: Function;
  judgementOnMeritsRequest: any;
  listings?: Listings;
  setExpertises?: Function;
  judgement: any;
  setJudgement: Function;
  expertiseJudgementAddDocumentId?: number;
  isRejected?: boolean;
  isContested?: boolean;
  isManager?: boolean;
  dahirAmount?: any;
  handleExpertiseChange?: Function;
  handleOpenContestation?: Function;
  civilJudgementType?: string;
  civj?: any;
  motifListExpertise?: any;
  civjvm?: any;
  handleCivJvmChange?: Function;
  judgementOnMerits?: any;
  sagisVictimInfo?: any;
  judgementForNonCompensation?: string;
  civjWithNonCompensation?: any;
  modeType: string;
  setCivilJudgementUpdateExpertise?: Function;
  civilJudgementUpdateExpertise?: any;
  setCivilJudgements?: Function;
  civilJudgements?: any;
  vehicle?: any;
  handleVehiculeChange?: Function;
  handleCivjVehicleChange?: Function;
}

export const GeneralCivilProceeding: React.FC<GeneralCivilProceedingProps> = (
  props,
): JSX.Element => {
  const MODES = {
    victimCivilJudgement: VictimExpertise,
    vehicleCivilJudgement: VehicleExpertise,
    formRejection: CivilWithNonCompensation,
    substantiveRejection: CivilWithNonCompensation,
    civilJudgementVictimRecap: CivilJudgementRecapVictim,
    civilJudgementVehicleRecap: CivilJudgementRecapVehicle,
    substantiveRejectionRecap: JudgementNonCompensationRecap,
    formRejectionRecap: JudgementNonCompensationRecap,
  } as any;
  const View = useMemo(() => {
    return MODES[props.mode];
  }, [props.mode]);
  return <View {...props} />;
};
export default injectIntl(GeneralCivilProceeding);
